import React from "react";
import { connect } from "react-redux";
import Layout from "@/Layout";
import QRCode from "qrcode-react";
import { getUrlWithAffCode } from "$ACTIONS/helper";
import { isWebPSupported } from "$ACTIONS/helper";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";

export async function getStaticProps() {
	return await getStaticPropsFromStrapiSEOSetting('/ดาวน์โหลด-fun88'); //參數帶本頁的路徑
}

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "1",
        };
    }
    render() {
        const { affiliateCode } = this.props;
        const downloadLinks = getUrlWithAffCode(affiliateCode);

        return (
            <Layout
                seoData={this.props.seoData}
                status={1}
            >
                <div className="common-distance-wrap down-wrap">
                    <div className="dow-distance">
                        <div className="content">
                            <img
                                className="hero-banner"
                                src={`/th/img/download/Image174.${
                                    isWebPSupported() ? "webp" : "jpg"
                                }`}
                            />
                            <div className="app-lists-box">
                                <div className="app-list-box">
                                    <div className="app-item">
                                        <img
                                            className="img-app-demo"
                                            src={`/th/img/download/FUNApp.${
                                                isWebPSupported()
                                                    ? "webp"
                                                    : "png"
                                            }`}
                                            alt="app"
                                        />
                                        <div className="text-box">
                                            <h1>ใหม่! เนทีฟแอป FUN88</h1>
                                            {/* 全新乐天堂APP */}
                                            <p>เข้าถึงง่ายแค่ปลายนิ้วสัมผัส</p>
                                            {/* 操作简易尽享指尖 */}
                                            <div className="qr-box">
                                                <QRCode
                                                    // logo={
                                                    //     "/th/img/download/qrcord.png"
                                                    // }
                                                    size={100}
                                                    value={downloadLinks}
                                                    // logoWidth={50}
                                                    // logoHeight={50}
                                                />
                                            </div>
                                            <p className="app-description">
                                                เพียงแค่สแกน QR
                                                Codeจะถูกลิงก์ไปหน้าดาวน์โหลดแอปมือถือ
                                                <br />
                                                เวอร์ชั่นล่าสุดโดยสามารถดูคู่มือการติดตั้งและขั้นตอนการดาวน์โหลดได้
                                                {/* 扫描二维码下载最新版乐天堂
                                                APP跳转至下载页面，查看下载教程并按步骤下载安装即可 */}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="app-list-box">
                                    <div className="app-item">
                                        <div className="text-box">
                                            <h1>แชทสด</h1>
                                            {/* 下载乐聊APP */}
                                            <p>ให้บริการทุกวันตลอด 24 ชม.</p>
                                            {/* 24/7随时为您服务 */}
                                            <div className="qr-box">
                                                <QRCode
                                                    // logo={
                                                    //     "/th/img/download/Group13571.png"
                                                    // }
                                                    size={100}
                                                    value={downloadLinks}
                                                    // logoWidth={50}
                                                    // logoHeight={50}
                                                />
                                            </div>
                                            <p className="app-description">
                                                เพียงแค่สแกน QR Code
                                                เพื่อดาวน์โหลดแชทสด
                                                <br />
                                                และติดต่อฝ่ายบริการลูกค้าได้ตลอด
                                                24 ชม.
                                                {/* 扫描二维码下载乐聊APP
                                                乐天使客服贴心为您提供24小时服务。 */}
                                            </p>
                                        </div>

                                        <img
                                            className="img-app-demo"
                                            src={`/th/img/download/AppDownload.${
                                                isWebPSupported()
                                                    ? "webp"
                                                    : "png"
                                            }`}
                                            alt="AppDownload"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        affiliateCode: state.mainSiteConfig.affiliateCode,
    };
};

export default connect(mapStateToProps, null)(Main);
